import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../components/text/DefaultText";
import { Ionicons } from "@expo/vector-icons";
import DefaultTextLight from "../../components/text/DefaultTextLight";
import { useNavigation } from "@react-navigation/native";

const NoDeviceScreen = (props) => {
  const navigation = useNavigation();

  return (
    <View style={styles.screen}>
      <Ionicons name="tv-outline" size={80} color="white" />
      <View style={styles.textContainer}>
        <DefaultText style={{ fontSize: 30 }}>No Connected Device</DefaultText>
      </View>
      <View style={styles.textContainer}>
        <DefaultTextLight style={{ fontSize: 16 }}>
          Pair a device to start casting
        </DefaultTextLight>
      </View>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          navigation.navigate("PairDeviceScreen");
        }}
      >
        <Text style={styles.pairText}>Pair Device</Text>
      </TouchableOpacity>
      {/* </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
    alignItems: "center",
    justifyContent: "center",
  },
  textContainer: {
    padding: 5,
  },
  buttonContainer: {
    backgroundColor: "white",
    width: "90%",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    margin: 50,
  },
  pairText: {},

  pairButton: {},
});

export default NoDeviceScreen;
